import { FieldError, UseFormRegisterReturn } from "react-hook-form";

interface FormInputProps {
  label?: string;
  type?: string;
  placeholder?: string;
  register?: UseFormRegisterReturn;
  error?: FieldError;
  disabled?: boolean;
}

const FormInput = ({
  label,
  type = "text",
  placeholder,
  register,
  error,
  disabled,
}: FormInputProps) => (
  <div className="flex flex-col gap-1.5">
    {label && <label className="text-sm text-[#4A4A4A]">{label}</label>}
    <input
      type={type}
      placeholder={placeholder}
      disabled={disabled}
      {...register}
      className={`w-full h-12 px-4 rounded-lg border bg-[#FAFAFA] text-sm text-dark-100 placeholder:text-[#BDBDBD] outline-none focus:border-[#CBA135] transition-colors disabled:opacity-50 disabled:cursor-not-allowed ${
        error ? "border-red-400 focus:border-red-400" : "border-[#E0E0E0]"
      }`}
    />
    {error && <p className="text-xs text-red-500">{error.message}</p>}
  </div>
);

export default FormInput;
